import { ajax } from 'rxjs/observable/dom/ajax';
import Cookies from 'js-cookie';

// Fork from AtoZNews App
// https://code.amazon.com/packages/AtoZNewsApp/blobs/mainline/--/src/client/ajax-client.ts
export const AjaxClient = new (class {
  get = (
    stage: string,
    url: string,
    data: {} | null,
    headers?: { [key: string]: string }
  ) => this.http(stage, 'get', url, data, headers);
  post = (
    stage: string,
    url: string,
    data: {} | null,
    headers?: { [key: string]: string }
  ) => this.http(stage, 'post', url, data, headers);

  http(
    stage: string,
    method: keyof typeof ajax,
    url: string,
    data: {} | null,
    headers: { [key: string]: string } = {}
  ) {
    const clientIdHeader = 'x-atoz-client-id';
    const contentTypeHeader = 'Content-Type';

    headers[contentTypeHeader] = 'application/json';
    headers[clientIdHeader] = 'ATOZ_NOTIFICATION_SERVICE';

    let baseUrl = '';

    switch (stage.toLowerCase()) {
      case 'prod':
        baseUrl = 'https://atoz-api.amazon.work';
        break;
      case 'development':
      case 'beta':
      default:
        headers['Authorization'] = 'Bearer ' + Cookies.get('atoz-oauth-token');
        baseUrl = 'https://atoz-api.integ.amazon.com';
        break;
    }

    const ajaxParams = {
      method: method,
      url: baseUrl + url,
      withCredentials: true,
      crossDomain: true,
      body: data || undefined,
      headers: headers,
    } as const;

    return ajax(ajaxParams).toPromise();
  }
})();
